<template>
    <div v-if="loaded">
        <div class="wrapper">
            <!-- header -->
            <Header :logo="footerInfo.logo" />
            <Body :homeInfo="homeInfo" :banner="homeInfo.banner" />
            <Footer :footerInfo="footerInfo" />
        </div>
    </div>
</template>
<script>
import AOS from 'aos'
import 'aos/dist/aos.css'
import { mapGetters } from 'vuex'

import Body from '../components/home/Body'
import Footer from '../components/home/Footer'
import Header from '../components/home/Header'

import { HomeHelper } from '@/common/crud-helpers/home'
import { FETCH_START, FETCH_SUCCESS } from '@/store/common'
export default {
    computed: {
        ...mapGetters(['footerInfo', 'homeInfo']),
    },
    components: {
        Footer,
        Header,
        Body,
    },
    data: () => {
        return {
            loaded: false,
            extraJSFiles: [
                'jquery-3.5.1.min.js',
                'popper.min.js',
                'bootstrap.min.js',
                'swiper-bundle.min.js',
                'jquery.dataTables.min.js',
            ],
            extraCssFiles: [
                'bootstrap.min.css',
                'jquery.dataTables.min.css',
                'swiper-bundle.css',
                'main.css',
            ],
        }
    },
    methods: {
        removeJsCssFile(filename, filetype) {
            let targetElement =
                filetype === 'js'
                    ? 'script'
                    : filetype === 'css'
                    ? 'link'
                    : 'none'
            let targetAttr =
                filetype === 'js' ? 'src' : filetype === 'css' ? 'href' : 'none'
            let allSuspects = document.getElementsByTagName(targetElement)
            for (let i = allSuspects.length; i >= 0; i--) {
                if (
                    allSuspects[i] &&
                    allSuspects[i].getAttribute(targetAttr) != null &&
                    allSuspects[i]
                        .getAttribute(targetAttr)
                        .indexOf(filename) !== -1
                )
                    allSuspects[i].parentNode.removeChild(allSuspects[i])
            }
        },
    },
    mounted() {
        setTimeout(() => {
            this.$store.commit(FETCH_SUCCESS)
            this.loaded = true
        }, 3000)
    },
    beforeCreate() {
        this.$store.commit(FETCH_START)
    },
    watch: {
        loaded() {
            if (this.loaded) {
                AOS.init({
                    disable: 'mobile',
                })
                this.$loadScript(`/assets/js/custom.js`)
            }
        },
    },
    created() {
        HomeHelper.getFooter()
        HomeHelper.getHomeDetails()
        document.body.classList.add('front-page')
        let head = document.getElementsByTagName('head')[0]
        this.extraJSFiles.forEach((file) => {
            this.$loadScript(`/assets/js/${file}`)
        })
        this.extraCssFiles.forEach((file) => {
            let link = document.createElement('link')
            link.rel = 'stylesheet'
            link.type = 'text/css'
            link.href = '/assets/css/' + file
            link.media = 'all'
            head.appendChild(link)
        })
    },
    beforeDestroy() {
        this.extraJSFiles.forEach((file) => {
            this.removeJsCssFile('custom.js', 'js')
            this.removeJsCssFile(`${file}`, 'js')
        })
        this.extraCssFiles.forEach((file) => {
            this.removeJsCssFile(`${file}`, 'css')
        })
    },
}
</script>
<style lang="css" scoped>
@import url('https://fonts.googleapis.com/css2?family=Almarai:wght@300;400;700;800&display=swap');
@import url('https://fonts.googleapis.com/css2?family=Fira+Sans:wght@100;200;300;400;500;600;700;800;900&display=swap');
@import url('https://fonts.googleapis.com/css2?family=Roboto:wght@100;300;400;500;700;900&display=swap');
@import url('https://fonts.googleapis.com/css2?family=Poppins:wght@100;200;300;400;500;600;700&display=swap');
</style>
